var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-global-menu-column",class:[{ fullWidth: _vm.fullWidth }]},[_c('div',{staticClass:"xs-title"},[_vm._t("title")],2),(_vm.$slots.default)?_c('div',{staticClass:"links"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }